module.exports = {
  COOKIES_AGREEMENT_KEY: 'cookiesAgreement',
  ONLY_TECH_COOKIES: 'only_tech',
  ALL_COOKIES: 'all',
};
